export class PasstDetalleCompletarModel{
    idPasstActividad: number;
    mes: number;
    idEstadoEjecucion?: number;
    mesReprogramado?: number;
    comentarios?: string;
    codigoEstadoProgramado?:string;
    constructor(){
        this.idPasstActividad = 0;
        this.mes = 0;
    }
}